module.exports = __webpack_public_path__ + "img/top-4.b7d021fe.png";